/**
 * Pflichtfelder der Formulare — Pendant zu den `[Required]`-Attributen des
 * Domänenmodells und zu `EditContext.Validate()`. Die Meldungstexte stehen
 * wörtlich so in `ErrorMessage` der DLL.
 */

import type { Container, Receipt } from '@/types/entities';

export interface RequiredRule<T> {
  field: keyof T & string;
  message: string;
}

/**
 * Pendant zu `RequiredAttribute.IsValid`: `null` ist ungültig, Texte zusätzlich, wenn sie
 * nur aus Leerzeichen bestehen. Nicht nullbare Zahlen und Enums sind damit stets gültig —
 * `[Required]` auf `Receipt.Rechnungsart` schlägt deshalb auch im Altclient niemals an.
 */
function isMissing(value: unknown): boolean {
  if (value === null || value === undefined) return true;
  return typeof value === 'string' && value.trim() === '';
}

/** Feldname → Meldung aller verletzten Regeln; Pendant zu `EditContext.GetValidationMessages`. */
export function requiredMessages<T extends object>(
  model: T,
  rules: RequiredRule<T>[],
): Map<string, string> {
  const messages = new Map<string, string>();
  for (const rule of rules) {
    if (isMissing(model[rule.field])) {
      messages.set(rule.field, rule.message);
    }
  }
  return messages;
}

export const containerRequiredRules: RequiredRule<Container>[] = [
  { field: 'ContainerNo', message: 'Es muss eine Containernummer hinterlegt werden.' },
  { field: 'ContTyp', message: 'Es muss ein Containertyp ausgewählt werden.' },
];

export const receiptRequiredRules: RequiredRule<Receipt>[] = [
  { field: 'DL', message: 'Es muss ein Dienstleister hinterlegt werden.' },
  { field: 'Rechnungsnummer', message: 'Es muss eine Rechnungsnummer hinterlegt werden.' },
  { field: 'Rechnungsart', message: 'Es muss eine Rechnungsart ausgewählt werden.' },
];
